import React, {useEffect, useState, useContext} from "react";
import { AppContext } from "../../App";


const WidgetAlpha = () => {

    const {globalCounter, setGlobalCounter} = useContext(AppContext)

    const[count, setCount] = useState(0)

    function increment(){
        setCount(count => count +1)
        setGlobalCounter(globalCounter+1)
    }

    function decrement(){
        setCount(count => count -1)
        setGlobalCounter(globalCounter+1)
    }

    useEffect(()=>{
        console.log("Counter value:"+ count)
    },[count])

    return (
        <div className="container bg-dark p-2 mt-2 px-4">
            <h3>Wdiget Alpha</h3>
            <p>Click: {count}</p>
            <button type="button" onClick={decrement} className="btn bg-light">-</button>
            <span> </span>  
            <button type="button" onClick={increment} className="btn bg-light">+</button>
        </div>
    )
}

export default WidgetAlpha